import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchConsentsCatalogueResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchConsentsCatalogue(): Promise<IFetchConsentsCatalogueResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/consents`,
    {
      validator: serverResponse,
    }
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(result.value);
}
